import { AddCircleOutlineOutlined, Refresh } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDrawer from "../../components/drawer/CustomDrawer";
import TableLoader from "../../components/loader/tableLoader";
import CustomTable from "../../components/table/CustomTable";
import StatusChip from "../../elements/StatusChip";
import {
  getAllAft,
  getAllAftNames,
  getAllOrgs,
} from "../../redux/actions/aftAction";
import { isAdmin } from "../../utils/helpers";
import { getDateAndTime } from "../../utils/timeUtils";
import ManageAFT from "./ManageAFT";
import TruncatedText from "../../elements/TruncatedText";

const AccountFactory = () => {
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state?.users?.loggedUser?.result);
  const { allAftList = [] } = useSelector((state) => state?.aft);
  const { globalLoader } = useSelector((state) => state.common);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(getAllOrgs());
    dispatch(getAllAftNames());
    fetchData();
    //eslint-disable-next-line
  }, []);

  const fetchData = () => {
    dispatch(getAllAft());
  };

  const columns = [
    {
      field: "accountName",
      label: "Account Name",
      render: (row) => <TruncatedText text={row.accountName} maxLength={40} />,
    },
    {
      field: "accountId",
      label: "Account ID",
      align: "left",
      render: (row) => row.accountId || "-",
    },
    {
      field: "status",
      label: "Status",
      render: (row) => {
        return <StatusChip status={row?.status} />;
      },
    },
    { field: "fullName", label: "Created By", align: "left" },
    {
      field: "createdDate",
      label: "Created Date",
      align: "left",
      render: (row) => <Box>{getDateAndTime(row?.createdDate)}</Box>,
    },
  ];

  return globalLoader ? (
    <TableLoader />
  ) : (
    <>
      <Box
        mb={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h5" gutterBottom={true}>
          Account Factory
        </Typography>
        <Box display="flex" sx={{ gridGap: "12px" }}>
          <Button
            variant="outlined"
            onClick={() => fetchData()}
            startIcon={<Refresh />}
          >
            Refresh
          </Button>
          <Button
            disabled={!isAdmin(loggedUser?.roles)}
            startIcon={<AddCircleOutlineOutlined />}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Create Account
          </Button>
        </Box>
      </Box>
      <CustomTable columns={columns} data={allAftList} />
      <CustomDrawer
        open={open}
        title="Account Details"
        onClose={() => setOpen(false)}
      >
        <ManageAFT
          onClose={() => {
            setOpen(false);
            fetchData();
          }}
        />
      </CustomDrawer>
    </>
  );
};

export default AccountFactory;
